import { StoreEnhancerStoreCreator } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance";

interface body  {
  HolidayName:string,
  HolidayDate:any,
  Istateid:number,
}

export const getHolidays= async(params={})=>{
    let response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_HOLIDAY_LIST,{
      params:{...params}
    });
    return response.data;
  }
  
export const getStateLsit = async ()=>{
  let response  = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.GET_STATE_LIST);
  let dt = response?.data?.data?.data;
  // console.log("🚀 ~ getStateLsit ~ dt:", dt)
  
  

 if (dt && Object.keys(dt)?.length > 0) {

    let data = Object?.entries(dt)?.map(([key,value]) => ({
      id: Number(key),
      name: typeof value === 'string' ? value.trim() : String(value),
    }), []);
    return { data };
  }
  return { data: [] };
};



  

interface Reqbody {
  HolidayName: string,
  HolidayDate: string,
  Istateid: number
}

export const updateHoliday = async({id,Reqbody}:{id:number,Reqbody:Reqbody})=>{
  const url =`${API_ENDPOINTS.CONFIGURATION.PUT_UPDATE_HOLIDAY}/${id}`
 let response =  await axiosInstance.put(url,Reqbody)
}

export const addHoliday = async(Reqbody:body)=>{ 

 const url = `${API_ENDPOINTS.CONFIGURATION.POST_AddHOLIDAY}` 
 let response =  await axiosInstance.post(url,Reqbody);
 return response.data;
}  
